import type { DownloadNfseLotePayload, DownloadNfseLoteResponse } from '../types';

/**
 * O download em lote de NFS-e está SUSPENSO (T313, 03/11/2026).
 *
 * Este módulo chamava `POST emalote-prod/download-em-lote` direto do navegador, com uma
 * credencial escrita aqui. A rota devolvia o ZIP com XML e PDF das notas de qualquer CNPJ do
 * pedido; o e-Malote CONFERE a credencial (no framework da Lambda, não no API Gateway), e o
 * problema é ela ser única e compartilhada — o mesmo valor viaja nos bundles do Angular, do
 * checkout e do backoffice, e estava escrito neste arquivo. Quem abre o DevTools de qualquer
 * um deles chamava a rota para o CNPJ que quisesse. A rota saiu do ar; o caminho de volta é
 * pelo servidor (SPEC-011), com a credencial guardada na ItWorks.Api.
 *
 * Fica como recusa explícita, e não como chamada que falha na rede: a tela já não oferece a
 * opção (`habilitarDownloadLoteNfse`), e um caminho que sobrasse precisa dizer o motivo em
 * vez de mostrar "erro ao baixar".
 */
export async function downloadNfseLoteApi(
  _payload: DownloadNfseLotePayload
): Promise<DownloadNfseLoteResponse> {
  throw new Error(
    'O download em lote de NFS-e está temporariamente indisponível. Ele volta quando o download passar pelo servidor.'
  );
}
